import React from 'react';

import { ActivityIndicator } from 'react-native';

export interface FOHCircleLoaderProps {}

export const FOHCircleLoader: React.FC<FOHCircleLoaderProps> = () => (
  <ActivityIndicator size="large" color="#51c1db" />
);
